import { Fragment, useEffect } from "react";
import { FieldColumnName } from "../../fields/FieldColumnName";
import { FieldDefaultFormulaFloat } from "../../fields/FieldDefaultFormulaFloat";
import { PanelProps } from "../ModalCreateColumn";

export const PanelCreateColumnFloat = ({
  autoFocus = true,
  isDefinitionEditable = true,
  fields,
  onFieldChange,
}: PanelProps) => {
  // Update column definition
  useEffect(() => {
    onFieldChange("definition", {
      value: {
        kind: "float",
        min: null,
        max: null,
      },
      isValid: true,
    });
  }, [onFieldChange]);

  return (
    <Fragment>
      <FieldColumnName
        autoFocus={autoFocus}
        value={fields.name.value}
        onChange={(field) => {
          onFieldChange("name", {
            value: field.value,
            isValid: field.isValid,
            isDirty: true,
          });
        }}
      />

      <FieldDefaultFormulaFloat
        value={fields.default_formula.value}
        onChange={(value) => {
          onFieldChange("default_formula", {
            value: value,
            isValid: value !== undefined && !isNaN(parseFloat(value)),
          });
        }}
      />
    </Fragment>
  );
};
